

import { useNavigate,useLocation } from 'react-router-dom';
import { useState,useEffect } from 'react';
import FooterButton from './FooterButton';
const importAll = (requireContext) => {
  const images = {};
  requireContext.keys().forEach((key) => {
    const cleanedKey = key.replace('./', '');
    images[cleanedKey] = requireContext(key);
  });
  return images;
};

const productImages = importAll(require.context('../productimage', false, /\.(png|jpe?g|jfif|webp)$/));

// Updated products array with category field
const products = [
  { name: 'Whopper with Cheese', image: 'burger-king-whopper-with-cheese-png-image-purepng-20.png', price: '₹249', description: 'Juicy flame‑grilled beef patty topped with melted cheese, lettuce, tomato & mayo—classic Whopper taste.', category: 'Fast Food' },
  { name: 'Cabbage per pc', image: 'cabbage per pc - vegetables.jpg', price: '₹35', description: 'Fresh green cabbage perfect for salads, coleslaw and cooking—crisp and nutritious.', category: 'Vegetables' },
  { name: 'Cake', image: 'cake.png', price: '₹499', description: 'Soft spongy chocolate cake layered with creamy frosting—ideal for celebrations.', category: 'Bakery' },
  { name: 'Cake 1', image: 'cake1.png', price: '₹599', description: 'Delicious layered vanilla‑berry cake with decorative icing—perfect birthday treat.', category: 'Bakery' },
  { name: 'Carrot red per kg', image: 'carrot red per kg - vegetables.jpg', price: '₹40', description: 'Crisp and sweet red carrots, great for juicing, salads or cooking.', category: 'Vegetables' },
  { name: 'Cauliflower 1 pc', image: 'cauliflower 1 pc - vegetables.jpg', price: '₹45', description: 'Fresh whole cauliflower—ideal for roasting, curries and healthy meals.', category: 'Vegetables' },
  { name: 'Chicken Category', image: 'chicken-category.png', price: '₹199', description: 'Premium fresh chicken pieces, ideal for curries, grills and everyday cooking.', category: 'Meat' },
  { name: 'Chocolate Ice Cream Sundae', image: 'chocolate-ice-cream-sundae-neapolitan-ice-cream-ice-cream-cream-food-frozen-dessert-thumbnail.png', price: '₹129', description: 'Creamy chocolate ice cream sundae topped with fudge and nuts—sweet indulgence.', category: 'Desserts' },
  { name: 'Classic Cheeseburger', image: 'classic-cheeseburger-with-beef-patty-pickles-cheese-tomato-onion-lettuce-and-ketchup-mustard-free-png.webp', price: '₹179', description: 'Grilled beef patty with cheese, pickles, tomato & lettuce in a soft bun—classic flavor.', category: 'Fast Food' },
  { name: 'Cream Ice Pistachio', image: 'cream-ice-pistachio.png', price: '₹139', description: 'Rich and creamy pistachio ice cream—nutty, refreshing dessert.', category: 'Desserts' },
  { name: 'Musk Melon', image: 'musk melon - fruits.jpg', price: '₹89', description: 'Juicy musk melon with sweet orange flesh—great for summer snacking.', category: 'Fruits' },
  { name: 'Ice Cream', image: 'ice-cream.png', price: '₹99', description: 'Classic vanilla ice cream, smooth and creamy—perfect dessert staple.', category: 'Desserts' },
  { name: 'Ice Cream Bowl', image: 'ice-cream-bowl-image.png', price: '₹149', description: 'Generous ice cream bowl topped with fresh fruits and sprinkles.', category: 'Desserts' },
  { name: 'Ice Cream Cup', image: 'Ice-Cream-Cup.png', price: '₹119', description: 'Single-serve ice cream cup—ideal for a quick sweet treat.', category: 'Desserts' },
  { name: 'Ice Cream Images', image: 'ice-cream-images.png', price: '₹109', description: 'Assorted mini ice creams in one pack—fun for kids and parties.', category: 'Desserts' },
  { name: 'Indian Garlic 200g', image: 'indian garlic  - 200g - vegetables.jpg', price: '₹39', description: 'Fresh 200g Indian garlic—aromatic, flavorful, perfect for cooking.', category: 'Vegetables' },
  { name: 'Mango PNG', image: 'mango-png-image-mongo-clipart-ripening-of-mango.png', price: '₹149', description: 'Ripe mango clipart PNG—bright, high-resolution image for designers.', category: 'Fruits' },
  { name: 'Mongo', image: 'mongo.png', price: '₹69', description: 'Whole mongo seeds—great source of plant protein and fiber.', category: 'Vegetables' },
  { name: 'Mongo Gourd Clipart', image: 'mongo-clipart-gourd-transparent-png.png', price: '₹59', description: 'Transparent mongo gourd clipart—ideal for food-themed design projects.', category: 'Vegetables' },
  { name: 'Orange', image: 'orange1.jfif', price: '₹55', description: 'Fresh juicy oranges—rich in vitamin C and refreshing.', category: 'Fruits' },
  { name: 'Paneer Tikka', image: 'paneer-tikka.png', price: '₹229', description: 'Marinated paneer tikka cubes—grilled and spicy, perfect appetizer.', category: 'Indian Dishes' },
  { name: 'Pepperoni Pizza', image: 'pepperoni-pizza-chicago-style-pizza-italian-cuisine-breakfast-oven-pizza-food-baking-plate.png', price: '₹349', description: 'Hot pepperoni pizza with gooey cheese and crisp crust—delicious Italian treat.', category: 'Fast Food' },
  { name: 'Pineapple', image: 'pineapple.jfif', price: '₹99', description: 'Fresh whole pineapple—sweet, tangy, great for smoothies or salads.', category: 'Fruits' },
  { name: 'Pineapple PNG', image: 'pineapple-fruit-tropical-fruit-natural-foods-ananas-ananas.png', price: '₹79', description: 'High-resolution pineapple PNG—perfect for digital art and menus.', category: 'Fruits' },
  { name: 'Pizza Hut Pizza', image: 'pizza-hut-pizza.png', price: '₹399', description: 'Classic Pizza Hut style pizza—rich toppings and cheesy goodness.', category: 'Fast Food' },
  { name: 'Dosa with Chutney', image: 'png-transparent-flatbread-with-dip-dosa-chutney-indian-cuisine-crepe-idli-rice-food-recipe-cuisine.png', price: '₹149', description: 'Crispy dosa served with coconut chutney—authentic South Indian dish.', category: 'Indian Dishes' },
  { name: 'Pasta with Meatballs', image: 'png-transparent-pasta-spaghetti-with-meatballs-italian-cuisine-cyborg-noodle-food-recipe-american-food.png', price: '₹279', description: 'Spaghetti pasta with juicy meatballs in rich tomato sauce.', category: 'Fast Food' },
  { name: 'Potato (per kg)', image: 'potato per kg - vegetables.jpg', price: '₹45', description: 'Fresh potatoes—versatile for boiling, frying, mashing or roasting.', category: 'Vegetables' },
  { name: 'Onion (5 kg)', image: 'onion 5 kg - vegetables.jpg', price: '₹180', description: 'Bulk 5kg onions—great value for cooking and everyday use.', category: 'Vegetables' },
  { name: 'Watermelon', image: 'watermelon - fruits.jpg', price: '₹129', description: 'Large watermelon—sweet, hydrating and perfect for hot days.', category: 'Fruits' },
  { name: 'Red Capsicum (200g)', image: 'red capsicum 200g - vegetables.jpg', price: '₹60', description: '200g fresh red capsicum—crunchy and colorful for salads.', category: 'Vegetables' },
  { name: 'Rice Bowl', image: 'rice-bowl-rice.png', price: '₹89', description: 'Hearty rice bowl with veggies—nutritious and filling meal.', category: 'Fast Food' },
  { name: 'Sandwich 1', image: 'Sandwich1.png', price: '₹129', description: 'Veg sandwich with fresh greens and mayo—tasty snack.', category: 'Fast Food' },
  { name: 'Sandwich 2', image: 'sandwich-sandwich.png', price: '₹139', description: 'Club sandwich with layers of veggies and cheese.', category: 'Fast Food' },
  { name: 'Sharad Seedless Grapes (500g)', image: 'sharad seedless grapes 500 - fruits.jpg', price: '₹199', description: '500g sweet seedless grapes—perfect for snacking.', category: 'Fruits' },
  { name: 'Strawberries & Cream (Tubzee Ice Cream)', image: 'Strawberries & Cream - Tubzee Ice Cream.jfif', price: '₹159', description: 'Creamy strawberries & cream ice cream tub—fruity delight.', category: 'Desserts' },
  { name: 'Thai Guava (2 pcs)', image: 'thai guava 2 pcs - fruits.jpg', price: '₹89', description: 'Two fresh Thai guavas—crisp, juicy and vitamin-rich.', category: 'Fruits' },
  { name: 'Veg Thali', image: 'thali-menu-veg-thali.png', price: '₹279', description: 'Assorted veg thali with curries, rice, roti & dessert.', category: 'Indian Dishes' },
  { name: 'Birthday Cake with Flowers', image: 'Birthday-cake-with-flowers.png', price: '₹699', description: 'Beauty of a flower-decorated birthday cake—rich & elegant.', category: 'Bakery' },
  { name: 'Brinjal (Nagpure)', image: 'brinjal nagpure - vegetables.jpg', price: '₹55', description: 'Fresh Nagpur brinjal—ideal for curries and frying.', category: 'Vegetables' },
  { name: 'Apple', image: 'apple.jfif', price: '₹49', description: 'Crisp red apple—sweet, juicy and healthy snack.', category: 'Fruits' },
  { name: 'Apple Sliced', image: 'apple1.jfif', price: '₹59', description: 'Sliced apple pack—convenient and ready to eat.', category: 'Fruits' },
  { name: 'Baby Kiwi', image: 'baby kiwi - fruits.jpg', price: '₹119', description: 'Mini baby kiwis—tart, sweet and seedless snack.', category: 'Fruits' },
  { name: 'Basmati Rice', image: 'basmati-rice-png.png', price: '₹199', description: 'Premium basmati rice—long grain, aromatic & fluffy.', category: 'Grains' },
  { name: 'Beetroot', image: 'beetroot - vegetables.jpg', price: '₹39', description: 'Fresh beetroot—sweet, earthy and great for juices.', category: 'Vegetables' },
  { name: 'Birthday Cake (Clipart)', image: 'birthday-cake-png-clip-art-birthday-cake-.png', price: '₹99', description: 'Birthday cake clipart PNG—bright and cute design.', category: 'Bakery' }
];

const ProductGallery = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('All');

  // Get unique categories for dropdown
  const categories = ['All', ...new Set(products.map(p => p.category))];
  // 👇 Handle category passed via navigation
  useEffect(() => {
    if (location.state?.category) {
      setSelectedCategory(location.state.category);
    }
  }, [location.state]);

  const filteredProducts = products.filter(product =>
    (selectedCategory === 'All' || product.category === selectedCategory) &&
    product.name.toLowerCase().includes(searchTerm.toLowerCase())
  );
 

  return (
    <div style={{ padding: '20px' }}>
      <h1 style={{ textAlign: 'center' }}>Product Gallery</h1>

      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
        <input
          type="text"
          placeholder="Search products..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          style={{ padding: '8px', width: '200px', marginRight: '10px' }}
        />

        <select
          value={selectedCategory}
          onChange={e => setSelectedCategory(e.target.value)}
          style={{ padding: '8px' }}
        >
          {categories.map(category => (
            <option key={category} value={category}>{category}</option>
          ))}
        </select>
      </div>

      <div
        style={{
          display: 'grid',
          
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '20px',
        }}
      >

{filteredProducts.map(({ name, image, price, description }) => (
  <div
    key={name}
    style={{
      border: '1px solid #ccc',
      borderRadius: '8px',
      padding: '16px',
      textAlign: 'center',
      background:'white',
      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
      cursor: 'pointer',
    }}
    // Remove onClick from div to avoid confusion with button click
  >
    <img
      src={productImages[image]}
      alt={name}
      style={{ width: '100%', height: '200px', objectFit: 'contain', marginBottom: '12px' }}
      onClick={() => navigate(`/products/${encodeURIComponent(name)}`)}
    />
    <h3 style={{color:'black'}}>{name}</h3>
    <p style={{ fontWeight: 'bold',color:'black' }}>{price}</p>
    <p style={{color:'black'}}>{description}</p>
   
<button
  onClick={() => navigate(`/buy/${encodeURIComponent(name)}`, { state: { name, price } })}
>
  Buy
</button>
  </div>
))}


      </div>
      <FooterButton></FooterButton>
    </div>
  );
};

export default ProductGallery;
